import React, { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { browserHistory } from "rdx/configureStore";
import { generateErrorUID } from "util/generate-error-uid";
import { useSession } from "hooks/useSession";
import { logToAirbrake } from "../../config/airbrake/log-to-airbrake";
import DrawerFallBack from "./Fallbacks/DrawerFallBack";
import type { ErrorBoundaryProps } from "./types";

type DrawerBoundaryProps = ErrorBoundaryProps & { closeDrawer: () => void };

export default function DrawerBoundary({ children, closeDrawer }: DrawerBoundaryProps) {
  const [errorUID, setErrorUID] = useState(generateErrorUID);
  const { session } = useSession();

  return (
    <ErrorBoundary
      fallbackRender={(fallbackProps) => (
        <DrawerFallBack {...fallbackProps} closeDrawer={closeDrawer} errorUID={errorUID} />
      )}
      onReset={() => setErrorUID(generateErrorUID())}
      onError={(error, info) => logToAirbrake({ error, info, errorUID, session, browserHistory })}
    >
      {children}
    </ErrorBoundary>
  );
}
